"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

exports.Skeleton = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children,
      loading = props.loading;
  var shineBlock = core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t0% {\n\t\t\tbackground-position: -32px;\n\t\t}\n\t\t40%, 100% {\n\t\t\tbackground-position: 420px;\n\t\t}\n\t"], ["\n\t\t0% {\n\t\t\tbackground-position: -32px;\n\t\t}\n\t\t40%, 100% {\n\t\t\tbackground-position: 420px;\n\t\t}\n\t"])));
  var skeletonContainer = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdiv {\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\tanimation: ", ";\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tdiv {\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\t", ";\n\t\t\t\tanimation: ", ";\n\t\t\t}\n\t\t}\n\t"])), loading && 'background: red', loading && 'background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px)', loading && 'background-size: 100%', loading && 'color: transparent', loading && 'border: none', core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t\t\t\t", " 1.8s infinite linear\n\t\t\t\t"], ["\n\t\t\t\t\t", " 1.8s infinite linear\n\t\t\t\t"])), shineBlock));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: skeletonContainer
  }, children);
});

if (utils_1.isDev) {
  exports.Skeleton.displayName = 'Skeleton';
}

var templateObject_1, templateObject_2, templateObject_3;